module.exports = __webpack_public_path__ + "img/jdDP.a1ae2f26.svg";